// Redirecionar após login no novo Customer Accounts
(function() {
  // Verificar se cliente está logado (variável passada do Liquid)
  if (typeof window.ShopifyCustomer === 'undefined') {
    return;
  }
  
  const isCustomerLoggedIn = window.ShopifyCustomer.loggedIn;
  const baseAccountUrl = window.ShopifyCustomer.accountUrl || '';
  const queryParams = window.ShopifyCustomer.queryParams || '';
  
  if (isCustomerLoggedIn && baseAccountUrl) {
    // Cliente está logado - verificar se deve redirecionar
    // Redirecionar para /profile
    if (sessionStorage.getItem('redirectToProfile') === 'true') {
      sessionStorage.removeItem('redirectToProfile');
      const profileUrl = baseAccountUrl + '/profile' + queryParams;
      if (window.location.pathname !== profileUrl.split('?')[0]) {
        window.location.href = profileUrl;
      }
    }
    
    // Redirecionar para /orders
    if (sessionStorage.getItem('redirectToOrders') === 'true') {
      sessionStorage.removeItem('redirectToOrders');
      const ordersUrl = baseAccountUrl + '/orders' + queryParams;
      if (window.location.pathname !== ordersUrl.split('?')[0]) {
        window.location.href = ordersUrl;
      }
    }
  } else {
    // Cliente não está logado - marcar intenção de redirecionar quando clicar no link de login
    document.addEventListener('DOMContentLoaded', function() {
      // Links para profile
      const profileLinks = document.querySelectorAll('[data-redirect-to-profile]');
      profileLinks.forEach(function(link) {
        link.addEventListener('click', function() {
          sessionStorage.setItem('redirectToProfile', 'true');
        });
      });
      
      // Links para orders
      const ordersLinks = document.querySelectorAll('[data-redirect-to-orders]');
      ordersLinks.forEach(function(link) {
        link.addEventListener('click', function() {
          sessionStorage.setItem('redirectToOrders', 'true');
        });
      });
    });
  }
})();

